/* eslint-disable @typescript-eslint/member-ordering */
import { Component, OnInit, Input, Output, EventEmitter, TemplateRef, ViewChild, ViewChildren, QueryList, ElementRef, AfterViewInit, ChangeDetectorRef, OnChanges, OnDestroy, SimpleChanges, HostListener } from '@angular/core';
import { ItineraryService } from '../../../../../../../shared/itinerary.service';
import { ModalsComponent } from 'app/shared/modals/modals.component';
import { MatDialog } from '@angular/material/dialog';
import { MatSelect } from '@angular/material/select';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { UserService } from 'app/pages/com.usblick.common/auth/user.service';
import { InsuranceQuoteModalComponent } from 'app/shared/modals/insurance-quote/insurance-quote-modal.component';
import { DynamicFontSizePipe } from 'app/shared/dynamic-font-size.pipe';
import { CompareModalComponent } from 'app/shared/compare-modal/compare-modal.component';
import CssFilterConverter from 'css-filter-converter';
import { Subscription } from 'rxjs';
import { ProductFactoryService } from 'services/itinerary/products/product-factory.service';
import { IInsuranceProduct } from 'model/insurance-product.interface';
import { IProductCreationParams } from 'model/product.interface';
import { HttpErrorResponse } from '@angular/common/http';
import { ModalViewVideComponent } from 'app/shared/modal-view-video/modal-view-video.component';
import { RestService } from 'app/shared/rest.service';
import { NotificationService } from '../../../../../../../shared/notifications/notification.service';

/**
 * Componente que muestra los resultados de seguros y permite su gestión
 * Incluye funcionalidades para comparar, agregar al itinerario, seleccionar planes y pasajeros
 */
@Component({
  selector: 'usb-insurance-result',
  templateUrl: './insurance-result.component.html',
  styleUrls: ['./insurance-result.component.scss'],
  providers: [DynamicFontSizePipe]
})
export class InsuranceResultComponent implements OnInit, AfterViewInit, OnChanges, OnDestroy {

  // ============================================
  // INPUT PROPERTIES - Datos recibidos del componente padre
  // ============================================

  /** Datos de búsqueda enviados desde el formulario principal */
  @Input() payload: any;

  /** Resultado individual del seguro a mostrar */
  @Input() result: any;

  /** Array completo de resultados para referencia */
  @Input() arrayResults: any;

  /** Índice del resultado actual en el array de resultados */
  @Input() index: number;

  /** Datos del formulario de búsqueda */
  @Input() form: any;

  /** Origen del componente para determinar comportamiento */
  @Input() origin: string;

  /** Indica si la comparación está deshabilitada */
  @Input() disbaledCompare: boolean;

  /** Configuraciones del cliente para personalización de UI */
  @Input() clientsSettingAppBooking: any;

  /** Items seleccionados para comparación */
  @Input() _itemToCompare: any;

  /** Lista de monedas disponibles */
  @Input() currencies: any[];

  /** Moneda preferida de la agencia */
  @Input() currencyAgency: any;

  /** Pasajeros seleccionados actualmente */
  @Input() paxesSelected: any[] = [];

  private originalPaxesSelected: any[] = [];

  /** Lista completa de pasajeros disponibles */
  @Input() paxesAvailability: any[] = [];

  // ============================================
  // OUTPUT PROPERTIES - Eventos emitidos al componente padre
  // ============================================

  /** Emite cuando se agrega o quita un item para comparación */
  @Output() addToCompare = new EventEmitter<any>();

  /** Emite cuando se solicita abrir la vista de comparación */
  @Output() toCompare = new EventEmitter<any>();

  /** Emite cuando se cierra un modal */
  @Output() modalClosedemitter = new EventEmitter<any>();

  /** Emite cuando cambia la selección de pasajeros */
  @Output() paxesChange = new EventEmitter<any[]>();

  /** Emite cuando se selecciona un plan desde la comparación */
  @Output() selectPlanSelectedCompareEmmit = new EventEmitter<any>();

  // ============================================
  // VIEW CHILDREN - Referencias a elementos del DOM
  // ============================================

  /** Referencias a los selectores de cobertura */
  @ViewChildren('coverageSelect') coverageSelects!: QueryList<any>;

  /** Referencias a los selectores de addons */
  @ViewChildren('addonSelect') addonSelects!: QueryList<any>;

  /** Referencias a los iconos para aplicar filtros de color */
  @ViewChildren('icons') icons: QueryList<ElementRef>;

  /** Referencias a los títulos de planes para scroll */
  @ViewChildren('titlePlanSelected') titlePlanSelected: QueryList<any>;

  /** Select de pasajeros. Se usa para cerrarlo manualmente al scrollear
   *  (ver `_closeSelectOnScroll`), porque el panel es un overlay del CDK
   *  que no sigue al trigger ni se cierra solo si el contenedor que
   *  scrollea no está registrado con `cdkScrollable` — y en ese caso
   *  queda flotando por encima del header fijo. */
  @ViewChild('paxSelect') paxSelect!: MatSelect;

  // ============================================
  // PRIVATE PROPERTIES
  // ============================================

  /** Suscripción para cambios en los iconos */
  private iconsSubscription: Subscription;

  /** Referencia al modal activo */
  modalRef: BsModalRef;

  /** Estilos para precios desde configuración del cliente */
  stylePathPrice: any;

  /** Ajustes de tamaño de fuente para diferentes longitudes de precios */
  fontSizeAdjustments = { 7: -2, 9: -5, 12: -7 };

  /** Contador de dígitos después del punto decimal en precios */
  countValueDot = 0;

  /** Control de vista para hoteles (legacy) */
  view_hotel = 0;
  isview_hotel = false;

  /** Control de estado del modal */
  modal = false;

  /** IDs de planes seleccionados */
  selectedPlanIds: number[] = [];

  /** Plan seleccionado actualmente */
  selectPlan: any;

  /** Copia original del resultado para restablecer cambios */
  originalResult: any;

  /** Pasajeros filtrados (disponibles menos seleccionados) */
  paxesFiltered: any[] = [];

  /** Control para mostrar todos los addons */
  showAllAddons = false;

  /** Control de expansión del listado de pasajeros seleccionados */
  isPaxesExpanded = false;

  /** Control para mostrar todos las coberturas */
  showAllCoverages = false;

  /** Control para mostrar tooltip de eliminación */
  showDeleteTooltip = false;

    ModalRooms: any;

  view_insurance = 0;

  chargePlan = false;

  selectedAddonCosts: { [key: string]: number } = {};

  /** Palabras clave para identificar tipos de modalidades de seguros */
  private modalityKeywords = [
    { type: 'Preexistencia', keywords: ['preexistencia', 'preexistente', 'pre-existencia'] },
    { type: 'Embarazo', keywords: ['embarazo', 'embarazada', 'gestación'] },
    { type: 'En viaje', keywords: ['viaje', 'itinerario', 'itinerary', 'travel'] }
  ];

  // ============================================
  // CONSTRUCTOR E INYECCIÓN DE DEPENDENCIAS
  // ============================================

  /**
   * Constructor del componente
   * @param itineraryService Servicio para gestión del itinerario
   * @param dialog Servicio para manejo de modales de Angular Material
   * @param userService Servicio de información del usuario
   * @param notificationService Servicio para notificaciones toast
   * @param productFactory Factory para creación de productos
   * @param cdrRef Referencia para detección de cambios
   */
  constructor(
    private itineraryService: ItineraryService,
    public dialog: MatDialog,
    public userService: UserService,
    private productFactory: ProductFactoryService,
    private notificationService: NotificationService,
    private cdrRef: ChangeDetectorRef,
    private _restService: RestService
  ) { }

  // ============================================
  // LIFECYCLE HOOKS
  // ============================================

  /**
   * Escucha clicks fuera del tooltip de eliminación para cerrarlo
   */
  @HostListener('document:click', ['$event'])
  onDocumentClick(event: MouseEvent): void {
    const target = event.target as HTMLElement;
    if (!target.closest('.delete-tooltip-container') && this.showDeleteTooltip) {
      this.showDeleteTooltip = false;
    }
  }

  /**
   * Maneja cambios en las propiedades de entrada
   * Actualiza la lista de pasajeros filtrados cuando cambian las selecciones
   */
  ngOnChanges(changes: SimpleChanges): void {
    if (changes['result'] && !changes['result'].firstChange) {
      this.coverageWidthPrincipals(this.result?.insurances);
    }
    this.actualizarPaxesFiltrados();
  }

  /**
   * Inicialización después de la vista
   * Configura suscripción para aplicar filtros de color a iconos
   */
  ngAfterViewInit() {
    // Suscribirse a los cambios del QueryList de iconos
    this.iconsSubscription = this.icons.changes.subscribe((icons: QueryList<ElementRef>) => {
      if (icons.length > 0) {
        // Esperar un tick para asegurar que el DOM esté listo
        setTimeout(() => {
          this.applyImageFilter();
        });
      }
    });

    // También aplicar filtro inicial si ya hay icons
    if (this.icons.length > 0) {
      this.applyImageFilter();
    }

    // El panel del mat-select de pasajeros es un overlay del CDK que no
    // está anclado al scroll de ningún contenedor sin `cdkScrollable`
    // (no hay ninguno en el proyecto), así que si scrolleás con el panel
    // abierto queda flotando en su posición original, por encima del
    // header fijo. Usamos capture:true para detectar el scroll de
    // CUALQUIER contenedor (no solo window), ya que 'scroll' no burbujea.
    document.addEventListener('scroll', this._closeSelectOnScroll, true);
  }

  /**
   * Limpieza antes de destruir el componente
   * Elimina suscripciones para prevenir memory leaks
   */
  ngOnDestroy() {
    if (this.iconsSubscription) {
      this.iconsSubscription.unsubscribe();
    }
    document.removeEventListener('scroll', this._closeSelectOnScroll, true);
  }

  /**
   * Cierra el select de pasajeros ante un scroll externo (ver ngAfterViewInit).
   * Si el scroll ocurre DENTRO del propio panel desplegado (el usuario
   * scrolleando la lista de pasajeros para ver más opciones), no hace nada
   * — sino nunca se podría ver la lista completa cuando hay muchos pasajeros.
   */
  private _closeSelectOnScroll = (event: Event): void => {
    if (!this.paxSelect?.panelOpen) {
      return;
    }
    const panelEl = this.paxSelect.panel?.nativeElement;
    const target = event.target as Node;
    if (panelEl && target && panelEl.contains(target)) {
      return;
    }
    this.paxSelect.close();
  };

  /**
   * Inicialización del componente
   * Configura estilos, addons, coberturas y crea copia de seguridad
   */
  ngOnInit() {
    // Obtener estilos de precios desde configuración del cliente
    this.stylePathPrice = JSON.parse(this.clientsSettingAppBooking?.clients_setting_app_booking?.bookingFlow_body);

    // Inicializar estructura de addons
    this.createAddonsEmpty();

    // Configurar iconos para coberturas principales
    this.coverageWidthPrincipals(this.result?.insurances);
    this.view_insurance = this.result.insurances[0]?.plan?.views;
    // Crear copia de seguridad del resultado original
    this.originalResult = this.deepCopy(this.result);

    // Filtrar pasajeros disponibles
    this.actualizarPaxesFiltrados();
  }

  // ============================================
  // MÉTODOS DE INICIALIZACIÓN
  // ============================================

  /**
   * Inicializa la estructura de addons para cada plan de seguro
   * Crea arrays vacíos para addons incluidos y precios
   */
  createAddonsEmpty(): void {
    this.result.insurances.forEach((insurance: any) => {
      insurance.plan.addonsIncluded = [];
      insurance.plan.netPriceBookingAddons = 0;
    });
  }

  /**
   * Crea una copia profunda de un objeto
   * @param obj Objeto a copiar
   * @returns Copia profunda del objeto
   */
  private deepCopy(obj: any): any {
    if (obj === null || typeof obj !== 'object') {
return obj;
}
    if (obj instanceof Date) {
return new Date(obj.getTime());
}
    if (obj instanceof Array) {
return obj.map(item => this.deepCopy(item));
}

    const copiedObj = {};
    for (const key in obj) {
      if (obj.hasOwnProperty(key)) {
        copiedObj[key] = this.deepCopy(obj[key]);
      }
    }
    return copiedObj;
  }

  // ============================================
  // MÉTODOS DE VALIDACIÓN DE COMPARACIÓN
  // ============================================

  /**
   * Verifica si la comparación está deshabilitada para este resultado
   * @returns true si está deshabilitada y no está en la lista de comparación
   */
  checkDisbaledCompare(): boolean {
    const index = this._itemToCompare.findIndex(val => val.title == this.result.title);
    if (this.disbaledCompare && index == -1) {
      return true;
    } else {
      return false;
    }
  }

  /**
   * Determina si mostrar el botón de comparación
   * @returns true si el resultado está en la lista de comparación
   */
  showCompareButton() {
    const index = this._itemToCompare.findIndex(val => val.title == this.result.title);
    if (index !== -1) {
      return true;
    } else {
      return false;
    }
  }

  // ============================================
  // MÉTODOS DE AGREGADO AL ITINERARIO
  // ============================================

  /**
   * Abre modal de confirmación para agregar un plan al itinerario
   * @param plan Plan de seguro a agregar
   */
async addToItinerary(item: any): Promise<any> {
  const loadingToast = this.notificationService.loading('Procesando producto...');

  return new Promise((resolve, reject) => {
    setTimeout(async () => {
      try {
        const categoryId: number = this.payload.categoriesId[0];
        const productService = this.productFactory.getProductService(categoryId);

        const others = {
          markInsurance: this.result
        };

        const productParams: IProductCreationParams = {
          item,
          product: this.result,
          payload: this.payload,
          categoryId,
          othersPerCategory: others
        };

        const result = productService.createProduct(productParams);
        this.notificationService.close(loadingToast);
        resolve(result);

      } catch (error) {
        this.notificationService.close(loadingToast);
        console.error('Error en addToItinerary:', error);
        this.notificationService.warning('Hay un problema en el producto');
        reject(error);
      }
    }, 100);
  });
}

// En el método add (con async):
async add(plan: any) {



  if(this.paxesSelected && this.paxesSelected.length === 0) {
    this.notificationService.info('Seleccione al menos un pasajero en un plan');
    return;
  }

  const plansSelected = this.deepCopy(this.paxesSelected);

  try {
    this.chargePlan = true;
    await this.updateViews(plansSelected);
  } catch (error) {
    console.error('Error al actualizar views:', error);
    this.notificationService.error('Error al procesar la solicitud');
    return;
  }
  const message = '';
  this.chargePlan = false;
    const dialogRef = this.dialog.open(InsuranceQuoteModalComponent, {
      width: 'auto',
      maxWidth: '1440px',
      panelClass: 'insurance-quote-modal-wide',
      data: {
        message,
        type: 'material',
        clientSetting: this.clientsSettingAppBooking,
        currencies: this.currencies,
        currencyAgency: this.currencyAgency,
        insurancePlan: plansSelected,
        quote: true
      },
      disableClose: false
    });

  dialogRef.afterClosed().subscribe(async (result: any) => {
    if (result && result.confirm) {
      // Guest sin file/owner todavía: se crea acá, ANTES de armar el producto,
      // porque createProduct() → getDestinationInfo() lee
      // userService.itineraryActive[0] y revienta si todavía no hay file
      // (no-op para agente real).
      await this.itineraryService.ensureGuestItinerary();

      const productItineraryArr: any[] = [];

      if(result.insurances && result.insurances.length > 0) {
        for (const insurance of result.insurances) {
          try {
            const planProduct = await this.addToItinerary(insurance.plan);
            if (planProduct) {
              productItineraryArr.push(planProduct);
            }
          } catch (error) {
            console.error('Error al procesar seguro:', error);
          }
        }
      }

      if (productItineraryArr && productItineraryArr.length > 0) {
        productItineraryArr.forEach((product: IInsuranceProduct) => {
          this.itineraryService.sendMessageSubscriptorLoading(true);
          this.handleProductAddition(product);

        });
        } else {
          // Caso cuando item es null/undefined
          this.notificationService.warning('No se pudo crear el producto');
        }

      const copy = this.deepCopy(this.originalResult);
      this.result.insurances = copy.insurances;

    } else {
      return;
    }
  });
}

updateViews(planSelected: any[]): Promise<any[]> {

  // Si no hay planes seleccionados, retornar promesa resuelta
  if (!planSelected || planSelected.length === 0) {
    return Promise.resolve([]);
  }

  // Crear array de promesas para cada plan
  const promises = planSelected.map((plan, index) => new Promise<any>((resolve, reject) => {
      // Si ya se actualizó la vista, resolver inmediatamente
      if (this.isview_hotel) {
        resolve({
          index,
          plan,
          status: 'already_updated',
          view_insurance:  this.view_insurance
        });
        return;
      }

        const payload = {
      categoryId: this.payload.categoriesId[0],
    };
      const planId = plan.insurancePlanId || plan.plan.planId; // Ajusta según tu estructura

      this._restService.doPut('app', `products/updateView/${planId}`, payload).subscribe(
        (response: any) => {
          if (response.success) {
            this.view_insurance = response.res.qtyview;
            this.isview_hotel = true;

            resolve({
              index,
              plan,
              status: 'success',
              response,
              view_insurance: this.view_insurance
            });
          } else {
            resolve({
              index,
              plan,
              status: 'failed',
              response,
              error: 'Response not successful'
            });
          }
        },
        (error) => {
          console.error(`Error en updateView para plan ${index}:`, error);
          reject({
            index,
            plan,
            status: 'error',
            error
          });
        }
      );
    }));

  // Retornar promesa que se resuelve cuando TODAS se completen
  return Promise.all(promises.map(p => p.catch(e => e))); // Capturar errores individuales sin romper todo
}

  /**
   * Maneja la respuesta del servidor al agregar un producto
   * @param item Producto a agregar
   * @param toastId ID del toast de carga para removerlo
   */
  private handleProductAddition(item: IInsuranceProduct): void {
    this.itineraryService.add(item).subscribe({
      next: (response: IInsuranceProduct) => {
        if (response) {

          this.notificationService.success('¡Felicitaciones! Producto agregado con éxito.');
          this.handleResItineraryUpdateSuccesfull();
          this.paxesChange.emit([]);
        } else {
          console.warn('Respuesta vacía del servidor:', response);
          this.notificationService.error('No se recibió confirmación del servidor', 'Error');
          this.paxesChange.emit([]);
        }
      },
      error: (error: HttpErrorResponse) => {
        console.error('Error adding product:', error);

        this.itineraryService.sendMessageSubscriptorLoading(false);

        // Mensaje de error más específico
        const errorMessage = this.getErrorMessage(error);
        this.notificationService.error(errorMessage, 'Error');
      }
    });
  }

  /**
   * Obtiene mensaje de error amigable basado en el tipo de error HTTP
   * @param error Error HTTP recibido
   * @returns Mensaje de error traducido
   */
  private getErrorMessage(error: HttpErrorResponse): string {
    if (error.status === 0) {
      return 'Error de conexión. Verifique su internet.';
    } else if (error.status >= 500) {
      return 'Error del servidor. Intente nuevamente.';
    } else {
      return 'Ha ocurrido un error al agregar el producto';
    }
  }

  /**
   * Maneja la actualización exitosa del itinerario
   * Actualiza impuestos, fechas y envía al servidor
   */
  private handleResItineraryUpdateSuccesfull(): void {
    this.itineraryService.sendMessageSubscriptorLoading(false);
    this.itineraryService.itinerary.totalTaxPrice = this.totalTax();
    this.itineraryService.itinerary.clientId = this.clientsSettingAppBooking?.id;
    this.itineraryService.itinerary.currency = this.result.insurances[0].plan.pricing.currency;
    // this.itineraryService.itinerary.arrivalDate = this.itineraryService.itinerary?.items[0].arrivalDate;
    // this.itineraryService.itinerary.departureDate = this.itineraryService.itinerary?.items[0].departureDate;
    this.itineraryService.evaluateDateItineraryRange(this.itineraryService.itinerary['items']);
    this.itineraryService.updateItinerary(this.itineraryService.itinerary);
  }

  /**
   * Calcula el total de impuestos incluidos en todos los items del itinerario
   * @returns Suma total de impuestos incluidos
   */
  totalTax() {
    let taxSum = 0;
    const itemTax: any[] = [];
    const items: any[] = this.itineraryService.itinerary.items;

    items.forEach(item => {
      if (item.taxes && item.taxes.length > 0) {
        item.taxes.forEach(tax => {
          itemTax.push(tax);
        });
      }
    });

    itemTax.forEach(tax => {
      if (typeof tax.included === 'boolean' && tax.included) {
        taxSum += tax.amount;
      }
    });

    return taxSum = parseFloat(taxSum.toFixed(2));
  }

  // ============================================
  // MÉTODOS DE COMPARACIÓN
  // ============================================

  /**
   * Emite evento para agregar o quitar item de comparación
   * @param event Evento del checkbox
   * @param item Item a comparar
   */
  _addToCompare(event: any, item: any) {
    const objeto = { item, action: (event.target.checked) ? 'add' : 'del' };
    this.addToCompare.emit(objeto);
  }

  /**
   * Emite evento para abrir vista de comparación
   */
  _toCompare() {
    this.toCompare.emit();
  }

  /**
   * Calcula el número de dígitos después del punto decimal para ajuste visual de precios
   * Basado en cantidad de habitaciones y precio por noche
   */
  getValueAfterDot() {
    if (this.result && this.result.additionalInfo) {
      const qntyRooms = this.payload.others.hotels.roomConfiguration.length;
      const optionNights = this.result?.additionalInfo?.rooms[0]?.room?.optionNightsNetTotalProf;
      const valueDot = Math.floor(Math.abs(optionNights * qntyRooms));

      this.countValueDot = valueDot.toString().length;
    }
  }

  // ============================================
  // MÉTODOS DE MODALES
  // ============================================

  /**
   * Abre modal para ver detalles del producto
   * @param template Plantilla del modal
   * @param tab Pestaña activa inicial
   */
  openModal(template: TemplateRef<any>, tab: any) {
    this.modal = true;

    const dialogRef = this.dialog.open(ModalsComponent, {
      width: '920px',
      panelClass: 'custom-container-transport',
      disableClose: true,
      data: {
        modalRoomRef: this.modalRef,
        product: this.result.insurances[0],
        departureDate: this.payload.departureDate,
        productQty: this.payload.qtyProduct,
        form: this.form,
        origin: 'INSURANCE',
        arrayResults: this.arrayResults,
        tabActive: tab,
        payload: this.payload
      },
    });

    dialogRef.afterClosed().subscribe((result) => {
      this.modalClosedemitter.emit();
    });
  }

  /**
   * Abre modal de video (implementación pendiente)
   * @param data Datos del video
   */
  openVideoModal(data: any): void {
      if(!data) {
        return;
      }
      const idVideo = this.getIdVideoYt(data);

      const dialogRef = this.dialog.open(ModalViewVideComponent, {
        width: '700px',
        data: idVideo,
      });
      dialogRef.afterClosed().subscribe((result) => {
        // Puede manejar el resultado aquí si es necesario
      });
  }


/**
 * Método que extrae el `id` de un video de YouTube desde su URL.
 *
 * Este método utiliza una expresión regular para extraer el `id` del video de una URL proporcionada de YouTube.
 *
 * @url -> URL del video de YouTube.
 * @returns El `id` del video si se encuentra, o `null` si no se encuentra un `id` válido.
 */
getIdVideoYt(url: any) {
  if(url) {
    const getIdVideo = /(?:youtu\.be\/|youtube\.com\/(?:embed\/|v\/|watch\?v=|watch\?.+&v=))([\w-]{11})/;
    const match = url.match(getIdVideo);
    return match ? match[1] : null;
  } else {
    return null;
  }
}

  // ============================================
  // MÉTODOS DE SELECCIÓN Y COMPARACIÓN DE SEGUROS
  // ============================================

  /**
   * Alterna selección de seguros para comparación o visualización
   * @param insurances Array de seguros a seleccionar
   * @param action Acción a realizar: 'compare' o 'view'
   */
  toggleInsuranceSelection(insurances: any[], action: string): void {
    if (action === 'compare') {
      this.itineraryService.toggleInsuranceSelection(insurances);
    }
    if (action === 'view') {
      this.itineraryService.toggleInsuranceSelection(insurances);
      this.comparePlans(false);
    }
  }

  /**
   * Verifica si los seguros están seleccionados
   * @param insurances Array de seguros a verificar
   * @returns true si todos están seleccionados
   */
  isInsuranceSelected(insurances: any[]): boolean {
    return this.itineraryService.isInsuranceSelected(insurances);
  }

  /**
   * Obtiene cantidad de seguros seleccionados
   * @returns Número de seguros seleccionados
   */
  getSelectedInsuranceCount(): number {
    return this.itineraryService.getSelectedInsuranceCount();
  }

  /**
   * Abre modal de comparación de planes de seguro
   * @param action Indica si es para comparación (true) o solo visualización (false)
   */
  comparePlans(action: boolean): void {
    const selectedInsurances = this.itineraryService.getSelectedInsurances();

    // Aplanar todos los planes de todos los insurances seleccionados
    const allPlansToCompare: any[] = [];

    selectedInsurances.forEach(insuranceGroup => {
      insuranceGroup.forEach(insurance => {
        if (insurance.plan) {
          allPlansToCompare.push({
            plan: insurance.plan,
            provider: insurance.provider,
            trip: insurance.trip,
            cancellationPolicy: insurance.cancellationPolicy,
            contact: insurance.contact,
            images: insurance.images,
          });
        }
      });
    });

    if (selectedInsurances && selectedInsurances.length < 2) {
      this.notificationService.info('Seleccione al menos 2 seguros para comparar');
      return;
    }

    if (selectedInsurances && selectedInsurances.length > 4) {
      this.notificationService.info('Recomendamos para una mejor experiencia eligir hasta cuatro marcas para comparar');
      return;
    }

    const width = '90vw';
    const maxWidth = '1440px';

    const dialogRef = this.dialog.open(CompareModalComponent, {
      disableClose: false,
      width,
      maxWidth,
      panelClass: 'compare-modal-wide',
      data: {
        selectedInsurances,
        allPlans: allPlansToCompare,
        clientSetting: this.clientsSettingAppBooking,
        currencyAgency: this.currencyAgency,
        currencies: this.currencies,
        compare: action,
        paxesSelected: this.paxesSelected
      }
    });

    dialogRef.afterClosed().subscribe((insurance: any) => {
      if (insurance) {
        this.selectPlanSelectedCompare(insurance);
      }
    });

    }

  /**
   * Abre el modal de detalle del plan de seguro.
   * Se dispara desde el botón "Ver más" del card.
   * Muestra Incluye y Adicionales sin tarifas ni datos de viaje.
   */
  openDetail(): void {
    const insurance = this.result.insurances[0];

    const fakePax = {
      insurance,
      insurancePlanId: insurance?.plan?.planId,
      age: 0,
      addons: insurance?.plan?.upgrades || [],
      tempId: 'detail-view'
    };

    this.dialog.open(InsuranceQuoteModalComponent, {
      width: 'auto',
      maxWidth: '1440px',
      panelClass: 'insurance-quote-modal-wide',
      data: {
        clientSetting: this.clientsSettingAppBooking,
        currencies: this.currencies,
        currencyAgency: this.currencyAgency,
        insurancePlan: [fakePax],
        quote: false,
        detail: true
      },
      disableClose: false
    });
  }

  // ============================================
  // MÉTODOS DE TÉRMINOS Y CONDICIONES
  // ============================================

  /**
   * Abre URL de términos y condiciones en nueva pestaña
   * @param url URL a abrir
   */
  getTermUrl(url: any) {
    if (url && this.isValidUrl(url)) {
      // Abrir en una pestaña nueva
      window.open(url, '_blank', 'noopener,noreferrer');
    } else {
      this.notificationService.info('Los términos y condiciones no están disponibles para este plan');
    }
  }

  /**
   * Valida si una URL es válida
   * @param url URL a validar
   * @returns true si la URL es válida
   */
  private isValidUrl(url: string): boolean {
    try {
      new URL(url);
      return true;
    } catch (e) {
      return false;
    }
  }

  // ============================================
  // MÉTODOS DE COBERTURAS Y ADDONS
  // ============================================
  coverageWidthPrincipals(insurances: any[]) {
    if (!insurances || insurances.length === 0) {
return;
}

    const ICON_BASE = '../../../../../assets/icons/search-result/insurance/';

    // 5 priority columns. Odontología is fallback-only: it fills a slot only if
    // one of the priority slots is empty.
    const PRIORITY_SLOTS: Array<{ name: string; iconPath: string; keywords: string[] }> = [
      { name: 'Accidente',     iconPath: ICON_BASE + 'accidente.svg',     keywords: ['accidente', 'muerte accidental', 'asistencia legal por accidente'] },
      { name: 'Enfermedad',    iconPath: ICON_BASE + 'enfermedad.svg',    keywords: ['enfermedad', 'covid', 'cuarentena'] },
      { name: 'Preexistencia', iconPath: ICON_BASE + 'preexistencia.svg', keywords: ['preexistenc', 'pre-existenc'] },
      { name: 'Medicamento',   iconPath: ICON_BASE + 'medicamento.svg',   keywords: ['medicament'] },
      { name: 'Equipaje',      iconPath: ICON_BASE + 'maleta.svg',        keywords: ['equipaj', 'maleta'] },
      { name: 'Odontología',   iconPath: ICON_BASE + 'odontologia.svg',   keywords: ['odontologia', 'odontolog', 'odonto'] },
    ];

    // Fallback slot: only used when a priority slot is empty.
    const FALLBACK_SLOT = {
      name: 'Odontología',
      iconPath: ICON_BASE + 'icono-caja-odontologia.svg',
      keywords: ['odontolog'],
    };

    insurances.forEach((insurance: any) => {
      const coverageList: any[] = insurance?.plan?.coverage?.coverageList;
      if (!coverageList || coverageList.length === 0) {
return;
}

      // Índice de origen (posición en la lista tal como llegó del backend).
      // Se fija solo la primera vez para que el matching de slots sea
      // idempotente: al reordenar la lista por cobertura, un findIndex por
      // keyword podria elegir otra cobertura que en la pasada anterior.
      coverageList.forEach((c: any, index: number) => {
        if (c._originIndex === undefined) {
          c._originIndex = index;
        }
      });

      // Working copy — we mutate this list as we assign slots.
      // Se ordena por _originIndex para que el emparejamiento por keyword
      // siempre parta del mismo orden que la primera vez.
      const remaining: any[] = [...coverageList].sort(
        (a: any, b: any) => (a._originIndex ?? 0) - (b._originIndex ?? 0)
      );
      const slotted: any[] = [];

      const assignedSlotNames = new Set<string>();

      for (const slot of PRIORITY_SLOTS) {
        const idx = remaining.findIndex((c: any) => {
          const text = (c.name || c.type || '').toLowerCase();
          return slot.keywords.some((kw: string) => text.includes(kw));
        });

        if (idx !== -1) {
          const coverage = remaining.splice(idx, 1)[0];
          coverage.icon = slot.iconPath;
          coverage._slotName = slot.name;
          coverage.isIncluded = typeof coverage?.coverage === 'string' ? true : false;
          slotted.push(coverage);
          assignedSlotNames.add(slot.name);
        }
      }

      // Fallback: only fill slots that the priority pass left empty.
      // Order: Odontología inserts into the first empty priority slot's position,
      // so the visible column order stays Accidente | ... | Odontología | ...
      if (!assignedSlotNames.has('Odontología')) {
        const idx = remaining.findIndex((c: any) => {
          const text = (c.name || c.type || '').toLowerCase();
          return FALLBACK_SLOT.keywords.some((kw: string) => text.includes(kw));
        });

        if (idx !== -1) {
          const coverage = remaining.splice(idx, 1)[0];
          coverage.icon = FALLBACK_SLOT.iconPath;
          coverage._slotName = FALLBACK_SLOT.name;
          coverage.isIncluded = typeof coverage?.coverage === 'string' ? true : false;

          // Find first priority slot position that wasn't filled and insert there.
          const firstEmptyIdx = PRIORITY_SLOTS.findIndex(s => !assignedSlotNames.has(s.name));
          if (firstEmptyIdx !== -1) {
            slotted.splice(firstEmptyIdx, 0, coverage);
            assignedSlotNames.add(FALLBACK_SLOT.name);
          } else {
            slotted.push(coverage);
          }
        }
      }

      // Remaining coverages keep original order, no icon
      remaining.forEach((c: any) => {
        c.icon = null;
        delete c._slotName;
      });

      // El orden final NO es el de los slots: el template solo muestra las
      // primeras 5 coberturas, así que el orden decide cuáles se ven.
      // Se ordena por cobertura: primero las textuales ("Incluido"),
      // luego las numéricas de menor a mayor.
      const ordered = this.sortCoveragesByAmount([...slotted, ...remaining]);

      // isIncluded debe quedar consistente en TODAS las coberturas (no solo
      // en las que entraron a un slot), porque el template decide entre
      // mostrar el texto o el <select> de montos según ese flag.
      ordered.forEach((c: any) => {
        c.isIncluded = this.isCoverageIncluded(c);
      });

      insurance.plan.coverage.coverageList = ordered;
    });
  }

  /**
   * Indica si una cobertura viene incluida en el plan (texto, p.ej. "Incluido")
   * o si tiene un monto numérico seleccionable.
   */
  private isCoverageIncluded(coverage: any): boolean {
    return typeof coverage?.coverage === 'string';
  }

  /**
   * Indica si la cobertura viene marcada como no incluida (p.ej. "No incluido",
   * "No aplica"). Misma convención que usa filters-model.ts para los filtros.
   */
  private isCoverageExcluded(coverage: any): boolean {
    return typeof coverage?.coverage === 'string'
      && /^no\b/i.test(String(coverage.coverage ?? '').trim());
  }

  /**
   * Ordena las coberturas de menor a mayor.
   *
   * Reglas:
   * 1. Las incluidas (texto, p.ej. "Incluido") van primero.
   * 2. Las numéricas van ascendentemente por monto.
   * 3. Las no incluidas (texto "No ...") y las sin valor van al final.
   *
   * El sort es estable: dentro de un mismo grupo se conserva el orden previo
   * (el de los slots de icono), así que no se pierde la prioridad visual.
   */
  private sortCoveragesByAmount(coverageList: any[]): any[] {
    return [...coverageList].sort((a: any, b: any) => {
      const aIncluded = this.isCoverageIncluded(a) && !this.isCoverageExcluded(a);
      const bIncluded = this.isCoverageIncluded(b) && !this.isCoverageExcluded(b);

      if (aIncluded && bIncluded) {
        return 0;
      }
      if (aIncluded) {
        return -1;
      }
      if (bIncluded) {
        return 1;
      }

      const aExcluded = this.isCoverageExcluded(a);
      const bExcluded = this.isCoverageExcluded(b);

      const aValue = aExcluded ? null : this.coverageAmount(a?.coverage);
      const bValue = bExcluded ? null : this.coverageAmount(b?.coverage);

      if (aValue === null && bValue === null) {
        return 0;
      }
      if (aValue === null) {
        return 1;
      }
      if (bValue === null) {
        return -1;
      }

      return aValue - bValue;
    });
  }

  /**
   * Extrae el monto numérico de una cobertura.
   * @returns El monto, o null si no es un número válido (null/undefined/NaN).
   */
  private coverageAmount(coverage: any): number | null {
    if (coverage === null || coverage === undefined || coverage === '') {
      return null;
    }

    const value = Number(coverage);
    return isNaN(value) ? null : value;
  }

  /**
   * Obtiene valores de cobertura específica de todos los planes
   *
   * Las opciones se devuelven ordenadas por monto de cobertura de menor a
   * mayor, que es como el usuario lee el select: primero el plan más barato
   * para esa cobertura. Las coberturas sin monto numérico (textuales como
   * "Incluido" o "No incluido") quedan al final.
   *
   * Cada opción conserva `_planIndex`, que es lo que usa selectCoverage() para
   * saber con qué plan corresponde la opción elegida; reordenar el array no
   * altera ese mapeo porque el value del <option> es el JSON completo.
   *
   * @param plans Array de planes de seguro
   * @param name Nombre de la cobertura a buscar
   * @returns Array de coberturas encontradas, ordenadas por monto ascendente
   */
  plansValueCoverage(plans: any, name: string): any[] {
    const arr: any[] = [];

    plans.forEach((plan: any, planIndex: number) => {
      if (plan.plan.coverage && plan.plan.coverage.coverageList.length > 0) {
        plan.plan.coverage.coverageList.forEach((coverage: any) => {
          if (coverage.name === name) {
            arr.push({ ...coverage, _planIndex: planIndex });
          }
        });
      }
    });

    // Sort estable: a igual monto se conserva el orden de plan.
    return arr.sort((a: any, b: any) => {
      const aValue = this.coverageAmount(a?.coverage);
      const bValue = this.coverageAmount(b?.coverage);

      if (aValue === null && bValue === null) {
        return 0;
      }
      if (aValue === null) {
        return 1;
      }
      if (bValue === null) {
        return -1;
      }

      return aValue - bValue;
    });
  }

  /**
   * Obtiene valores de addons específicos de todos los planes
   * @param plans Array de planes de seguro
   * @param name Nombre del addon a buscar
   * @returns Array de addons encontrados
   */
  plansValueAddons(plans: any, name: string): any[] {
    const arr: any[] = [];

    plans.forEach((plan: any) => {
      if (plan.plan.upgrades && plan.plan.upgrades.length > 0) {
        plan.plan.upgrades.forEach((addon: any) => {
          if (addon.name === name) {
            arr.push(addon);
          }
        });
      }
    });

    return arr;
  }

  // ============================================
  // MÉTODOS DE SELECCIÓN Y NAVEGACIÓN DE PLANES
  // ============================================

  /**
   * Emite evento cuando se selecciona un plan desde la comparación
   * @param value Plan seleccionado
   */
  selectPlanSelectedCompare(value: any): void {
    this.selectPlanSelectedCompareEmmit.emit(value);
    setTimeout(() => {
      this.resetAllSelectsToFirstPlan();
    }, 100);
  }

  /**
   * Realiza scroll suave hacia un plan específico
   * @param planName Nombre del plan a navegar
   */
  scrollToPlan(planName: string): void {
    // Buscar el elemento que coincida con el planName
    const elements = this.titlePlanSelected.toArray();
    const targetElement = elements.find((el: ElementRef, index: number) =>
      // Comparar el texto del elemento con el planName buscado
       el.nativeElement.textContent.trim() === planName
    );

    if (targetElement) {
      targetElement.nativeElement.scrollIntoView({
        behavior: 'smooth',
        block: 'center',
        inline: 'nearest'
      });

      // Opcional: agregar efecto visual temporal
      this.highlightElement(targetElement.nativeElement);
    }
  }

  /**
   * Aplica efecto de resaltado temporal a un elemento
   * @param element Elemento a resaltar
   */
  highlightElement(element: HTMLElement): void {
    element.classList.add('highlight-plan');
    setTimeout(() => {
      element.classList.remove('highlight-plan');
    }, 2000);
  }

  /**
   * Selecciona un plan basado en cobertura seleccionada
   * @param value Valor de cobertura seleccionado (JSON string)
   */
  selectCoverage(value: string): void {
    const parsedValue: any = JSON.parse(value);

    const findPlanIndex = typeof parsedValue._planIndex === 'number'
      ? parsedValue._planIndex
      : this.result.insurances.findIndex((plan: any) =>
          plan.plan.coverage?.coverageList?.some((c: any) =>
            c.name === parsedValue.name && c.coverage === parsedValue.coverage
          )
        );

    if (findPlanIndex > 0) {
      [this.result.insurances[0], this.result.insurances[findPlanIndex]] =
        [this.result.insurances[findPlanIndex], this.result.insurances[0]];

      this.resetAllSelectsToFirstPlan();
    }
  }

  // /**
  //  * Selecciona un plan basado en addon seleccionado
  //  * @param value Valor de addon seleccionado (JSON string)
  //  */
  // selectAddons(value: string): void {
  //   const parsedValue: any = JSON.parse(value);

  //   const findPlanIndex = this.result.insurances.findIndex((plan: any) =>
  //     plan.plan.upgrades.some((c: any) =>  // ← Cambiar a SOME
  //       c.name === parsedValue.name && c.cost === parsedValue.cost
  //     )
  //   );

  //   if (findPlanIndex > 0) {
  //     [this.result.insurances[0], this.result.insurances[findPlanIndex]] =
  //       [this.result.insurances[findPlanIndex], this.result.insurances[0]];

  //     this.resetAllSelectsToFirstPlan();
  //   }
  // }

  selectAddon(addon: any, costIndex: string): void {
  this.selectedAddonCosts[addon.name] = parseInt(costIndex);

  const isIncluded = this.getAddonsIncluded(this.result?.insurances, addon);

  // El botón "AGREGAR +" se oculta una vez que el addon ya está incluido
  // (ver *ngIf="!getAddonsIncluded(...)" en el template), así que cambiar
  // el <select> es la única forma de notificar el nuevo costIndex cuando
  // el addon ya está agregado — sin este call, addAddons() nunca se
  // entera del cambio y el precio queda desincronizado del selector.
  if (isIncluded) {
    this.addAddons(this.result?.insurances, addon, true);
  }
}

  /**
   * trackBy para los *ngFor que iteran sobre getAddonSlots().
   * Usa `name` como clave estable: el `name_upgrade` del grupo (formato nuevo)
   * o el `name` del upgrade (formato viejo). Esto evita que Angular destruya
   * y recree el DOM cada vez que getAddonSlots() devuelve referencias nuevas
   * por el re-cómputo de groupUpgradesByName().
   */
  trackByAddonName = (_: number, slot: any): string => {
    return slot?.name ?? '__null__';
  };

  /**
   * trackBy para los <option> de cada <select> de cobertura.
   * Sin esto, plansValueCoverage() devuelve objetos nuevos en cada change
   * detection (porque hace spread), Angular no puede matchear y destruye
   * los <option> existentes — el <select> pierde su value y a veces
   * hasta el evento (change) que el usuario acaba de disparar.
   */
  trackByCoverageOption = (_: number, cover: any): string => {
    return `${cover?._planIndex ?? '_'}::${cover?.name ?? '_'}::${cover?.coverage ?? '_'}`;
  };

  /**
   * Devuelve un array de 5 slots para el bloque de Adicionales.
   *
   * Si TODOS los upgrades vienen con `name_upgrade` y `coverage_upgrade`
   * (formato nuevo), los agrupa por `name_upgrade`: cada grupo conserva
   * un `cost` combinado con todas las variantes, y se renderiza como una
   * sola fila con un select que lista los `coverage_upgrade`.
   *
   * Si CUALQUIER upgrade NO trae esos campos (formato viejo), se devuelve
   * el array crudo tal cual estaba antes — sin agrupar, sin romper.
   *
   * Los primeros N slots son los reales; el resto (hasta 5) son null
   * y se renderizan como placeholder.
   */
  getAddonSlots(): any[] {
    const upgrades: any[] = this.result?.insurances?.[0]?.plan?.upgrades || [];

    // Modo mixto: agrupa los upgrades que vienen con name_upgrade + coverage_upgrade
    // (formato nuevo) y deja pasar crudos los que no (formato viejo / cobertura única).
    // Antes se exigía que TODOS tuvieran esos campos, y bastaba un coverage_upgrade
    // null para deshabilitar el agrupado entero.
    const isGroupable = (u: any) => !!(u?.name_upgrade && u?.coverage_upgrade);
    const groupable = upgrades.filter(isGroupable);
    const legacy = upgrades.filter(u => !isGroupable(u));

    const source: any[] = [...this.groupUpgradesByName(groupable), ...legacy];

    return source;
  }

  /**
   * Primeros 5 adicionales (post-agrupamiento) para la fila siempre visible.
   * Rellena con null hasta llegar a 5 — los null se renderizan como placeholder.
   */
  getAddonFirstFive(): any[] {
    const source = this.getAddonSlots();
    const slots: any[] = [...source];
    while (slots.length < 5) {
      slots.push(null);
    }
    return slots.slice(0, 5);
  }

  /**
   * Adicionales restantes (a partir del índice 5). Se renderizan dentro del
   * bloque expandible que se muestra al hacer "Ver más".
   */
  getAddonRest(): any[] {
    const source = this.getAddonSlots();
    return source.slice(5);
  }

  /**
   * Cantidad REAL de adicionales a mostrar (post-agrupamiento si aplica).
   * Usado por el botón "Ver más" para saber si hay overflow más allá de los
   * 5 slots iniciales. No cuenta nulls (placeholders).
   */
  getAddonRealCount(): number {
    return this.getAddonSlots().filter(s => s !== null).length;
  }

  /**
   * Agrupa upgrades que comparten `name_upgrade` en un único objeto.
   * El objeto resultante tiene:
   *   - name: name_upgrade (cortos, se muestra como label)
   *   - description: el name completo original (para tooltip)
   *   - type: el type del primer elemento del grupo
   *   - cost: [costo_var1, costo_var2, ...] (se conserva el orden original)
   *   - coverage_upgrade_list: [cov1, cov2, ...] (para renderizar el select)
   *   - _grouped: true (marca interna para el template)
   *   - _originalUpgrades: los upgrades originales del grupo (por si hace
   *     falta reconstruir el objeto que se guarda en addonsIncluded)
   */
  private groupUpgradesByName(upgrades: any[]): any[] {
    const groups = new Map<string, any>();

    upgrades.forEach(u => {
      const key = u.name_upgrade;
      if (!groups.has(key)) {
        groups.set(key, {
          name: u.name_upgrade,
          description: u.name,
          type: u.type,
          cost: [],
          coverage_upgrade_list: [],
          _originalUpgrades: [],
          _grouped: true
        });
      }
      const g = groups.get(key);
      const costValue = Array.isArray(u.cost) ? Number(u.cost[0] || 0) : Number(u.cost || 0);
      g.cost.push(costValue);
      g.coverage_upgrade_list.push(u.coverage_upgrade);
      g._originalUpgrades.push(u);
    });

    return Array.from(groups.values());
  }

  /**
   * Restablece todos los selectores al primer plan
   * Sincroniza los selects con el plan actualmente seleccionado
   */
  resetAllSelectsToFirstPlan(): void {
    setTimeout(() => {
      this.coverageSelects.forEach((select, index) => {
        const currentCoverage = this.result.insurances[0]?.coverage?.coverageList?.[index];
        if (!currentCoverage) {
          return;
        }

        // Los <option> se construyen con plansValueCoverage(), que adjunta
        // _planIndex a cada cobertura. nativeElement.value matchea contra los
        // options por string equality, así que tenemos que setear el value
        // con la MISMA forma que usó el template: el coverage actual del
        // primer plan con _planIndex = 0. Si no, el select queda visualmente
        // en blanco después del swap.
        const coverageValue = JSON.stringify(
          { ...currentCoverage, _planIndex: 0 },
          null,
          2
        );

        select.nativeElement.value = coverageValue;

        this.view_insurance = this.result.insurance[0]?.plan?.views;
      });
    });
  }

  // ============================================
  // MÉTODOS DE PERSONALIZACIÓN DE UI
  // ============================================

  /**
   * Aplica filtro de color a los iconos basado en configuración del cliente.
   * Convierte el color principal del cliente a filtro CSS.
   * Aplica filtro de color SOLO al icono de cobertura de equipaje.
   * Los iconos de la barra de herramientas y los demás iconos de cobertura
   * (enfermedad, accidente, odontologia, medicamentos) NO se filtran.
   */
  applyImageFilter() {
    const color = this.clientsSettingAppBooking?.clients_setting_global?.color_main_1;

    if (!color) {
      console.warn('No color defined');
      return;
    }

    try {
      const tempFilterObj = CssFilterConverter.hexToFilter(color, { sheen: false });
      const tempFilterStr = Object.keys(tempFilterObj).map(key => `${key}(${tempFilterObj[key]})`).join(' ');
      const colorRegex = /color\((.*)\)/;
      const colorMatch = tempFilterStr.match(colorRegex);
      const colorFilter = colorMatch ? colorMatch[1] : '';
      const filter = colorFilter;

      this.icons.forEach((icon, index) => {
        if (icon && icon.nativeElement) {
          const el = icon.nativeElement;
          el.style.width = '21px';
        }
      });
    } catch (error) {
      console.error('Error applying image filter:', error);
    }
  }

  // ============================================
  // MÉTODOS DE GESTIÓN DE ADDONS
  // ============================================

  /**
   * Verifica si un addon está incluido en el plan actual
   * @param insurances Array de seguros
   * @param addon Addon a verificar
   * @returns true si el addon está incluido
   */
  getAddonsIncluded(insurances: any[], addon: any): boolean {
    if (!insurances?.[0]?.plan?.addonsIncluded) {
      return false;
    }
    return !!insurances[0].plan.addonsIncluded.find(c => c.name === addon.name);
  }

    /**
     * Agrega o quita addons del plan actual y actualiza precios
     * @param insurances Array de seguros
     * @param addon Addon a agregar/quitar
     * @param action true para agregar, false para quitar
     */

  addAddons(insurances: any[], addon: any, action: boolean): void {
    if (!insurances?.[0]?.plan) {
return;
}

    const firstInsurance = insurances[0];

    // Determinar qué costo usar
    let addonCost = 0;
    if (Array.isArray(addon.cost)) {
      const selectedIndex = this.selectedAddonCosts[addon.name] || 0;
      addonCost = Number(addon.cost[selectedIndex] || 0);
    } else {
      addonCost = Number(addon.cost || 0);
    }

    if (!firstInsurance.plan.addonsIncluded) {
      firstInsurance.plan.addonsIncluded = [];
    }

    const index = firstInsurance.plan.addonsIncluded.findIndex((c: any) => c.name === addon.name);

    if (index === -1) {
      firstInsurance.plan.addonsIncluded.push({
        ...addon,
        selectedCostIndex: this.selectedAddonCosts[addon.name] || 0
      });
      this.updatePrices(firstInsurance.plan, addonCost, true);
    } else if (index !== -1 && action) {
      // Ya está incluido pero el usuario cambió el upgrade seleccionado
      // (otro costIndex): hay que revertir lo que valía antes (según el
      // selectedCostIndex que tenía guardado ese addon) y recién después
      // aplicar el costo nuevo, sino el precio anterior queda sumado.
      const existingAddon = firstInsurance.plan.addonsIncluded[index];
      const previousCostIndex = existingAddon.selectedCostIndex || 0;
      const previousCost = Array.isArray(existingAddon.cost)
        ? Number(existingAddon.cost[previousCostIndex] || 0)
        : Number(existingAddon.cost || 0);

      this.updatePrices(firstInsurance.plan, previousCost, false);
      this.updatePrices(firstInsurance.plan, addonCost, true);

      existingAddon.selectedCostIndex = this.selectedAddonCosts[addon.name] || 0;
    } else if (!action) {
      // Restar según el selectedCostIndex guardado en el addon (lo que
      // efectivamente está sumado al precio), no según el valor actual
      // del <select> — si llegaran a desincronizarse, esto evita restar
      // un monto que nunca se sumó.
      const existingAddon = firstInsurance.plan.addonsIncluded[index];
      const storedCostIndex = existingAddon?.selectedCostIndex || 0;
      const costToRemove = Array.isArray(existingAddon?.cost)
        ? Number(existingAddon.cost[storedCostIndex] || 0)
        : Number(existingAddon?.cost || 0);

      firstInsurance.plan.addonsIncluded.splice(index, 1);
      this.updatePrices(firstInsurance.plan, costToRemove, false);
    }
  }

  /**
   * Actualiza todos los precios del plan al agregar/quitar addons
   * @param plan Plan a actualizar
   * @param cost Costo del addon
   * @param isAdding true si se agrega, false si se quita
   */
  private updatePrices(plan: any, cost: number, isAdding: boolean): void {
    const amount = isAdding ? cost : -cost;

    plan.netPriceBookingAddons = (plan.netPriceBookingAddons || 0) + amount;
    plan.totalPriceProf = (plan.totalPriceProf || 0) + amount;
    plan.totalPriceFreeTax = (plan.totalPriceFreeTax || 0) + amount;
    plan.netPriceFreeTax = (plan.netPriceFreeTax || 0) + amount;
    plan.netPriceProf = (plan.netPriceProf || 0) + amount;
    plan.profility.netPrice = (plan.profility.netPrice || 0) + amount;
    plan.profility.netPriceCategory = (plan.profility.netPriceCategory || 0) + amount;
    plan.profility.netPriceProvider = (plan.profility.netPriceProvider || 0) + amount;
    plan.profility.netPriceBooking = (plan.profility.netPriceBooking || 0) + amount;
  }

  /**
   * Obtiene servicios extra (addons) de un item
   * @param item Item a extraer servicios
   * @returns Array de servicios extra
   */
  private getServiceExtra(item: any): any[] {
    const arr: any[] = [];

    if (item.addonsIncluded && item.addonsIncluded.length > 0) {
      item.addonsIncluded.forEach((addons: any) => {
        arr.push({
          name: addons.name,
          price: addons.cost
        });
      });
    }

    return arr;
  }

  // ============================================
  // MÉTODOS DE GESTIÓN DE PASAJEROS
  // ============================================

  /**
   * Actualiza lista de pasajeros filtrados (disponibles - seleccionados)
   */
  actualizarPaxesFiltrados() {
    // Filtrar paxes disponibles excluyendo los ya seleccionados
    // paxesSelected[i] puede llegar undefined (más resultados que selecciones tras una nueva búsqueda)
    const paxesSelected = this.paxesSelected || [];
    this.paxesFiltered = (this.paxesAvailability || []).filter(pax =>
      !paxesSelected.some(selected =>
        JSON.stringify(selected) === JSON.stringify(pax)
      )
    );
    this.originalPaxesSelected = [...paxesSelected];
  }

onSelectionChange(event: any, insurance: any) {
  // Proveedor sin discriminación por tipo de pasajero: el select solo tiene la
  // opción sentinel 'group' (ver isGroupSelectionOnly()). Traducirla a selección
  // de todo el grupo en vez de tratarla como un pasajero individual.
  if (this.isGroupSelectionOnly()) {
    const isGroupChecked = Array.isArray(event.value) && event.value.includes('group');
    this.onGroupSelectionChange(isGroupChecked, insurance);
    return;
  }

  const seleccionDelSelect = event.value; // Lista COMPLETA del select

  // 1. Identificar qué paxes son NUEVOS (no estaban antes)
  const paxesNuevos = this.identificarPaxesNuevos(seleccionDelSelect);

  if (paxesNuevos.length === 0) {
    // No hay nuevos, solo se removieron algunos
    // Enviar la lista actual del select (ya filtrada)
    const seleccionConSeguro = this.agregarSeguroSiFalta(seleccionDelSelect, insurance);
    this.paxesChange.emit(seleccionConSeguro);
    return;
  }

  // 2. COMBINAR: lo que ya tenía + los nuevos
  const seleccionCombinada = [
    ...(this.paxesSelected || []),  // Lo que ya estaba seleccionado
    ...paxesNuevos                   // Los nuevos
  ];

  // 3. Asignar insurance a los NUEVOS (los que ya tenían mantienen su insurance)
  const seleccionFinal = this.asignarSeguroANuevos(seleccionCombinada, paxesNuevos, insurance);

  // 4. Emitir al padre
  this.paxesChange.emit(seleccionFinal);
}

/**
 * Identifica qué paxes son nuevos (no estaban en la selección anterior)
 */
private identificarPaxesNuevos(nuevaSeleccion: any[]): any[] {
  if (!this.paxesSelected || this.paxesSelected.length === 0) {
    return nuevaSeleccion; // Todos son nuevos
  }

  // Crear Set de IDs de paxes ya seleccionados
  const idsExistentes = new Set(this.paxesSelected.map(p => p.tempId));

  // Filtrar solo los que NO están en el Set
  return nuevaSeleccion.filter(pax => !idsExistentes.has(pax.tempId));
}

/**
 * Asigna insurance solo a los paxes NUEVOS
 */
private asignarSeguroANuevos(
  seleccionCombinada: any[],
  paxesNuevos: any[],
  insurance: any
): any[] {
  // Crear Set de IDs de paxes nuevos para rápido acceso
  const idsNuevos = new Set(paxesNuevos.map(p => p.tempId));

  return seleccionCombinada.map(pax => {
    // Si este pax es NUEVO, agregarle insurance
    if (idsNuevos.has(pax.tempId)) {
      return {
        ...pax,
        insurance: { ...insurance }, // Clonar insurance
        insuranceSelectedAt: new Date().toISOString(),
        insurancePlanId: insurance?.plan?.planId
      };
    }

    // Si ya existía, mantenerlo tal cual (con su insurance original)
    return pax;
  });
}

/**
 * Para cuando solo se removieron paxes (no se agregaron nuevos)
 */
private agregarSeguroSiFalta(paxes: any[], insurance: any): any[] {
  return paxes.map(pax => {
    // Si el pax ya tiene insurance, mantenerlo
    if (pax.insurance && pax.insurance.plan?.planId) {
      return pax;
    }

    // Si no tiene, agregarle este insurance
    return {
      ...pax,
      insurance: { ...insurance },
      insuranceSelectedAt: new Date().toISOString()
    };
  });
}
  /**
   * Remueve un pasajero de la lista seleccionada
   * @param index Índice del pasajero a remover
   */
  removerPax(index: number) {
    // Selección por grupo: no se puede sacar un pasajero suelto (el precio ya es
    // el del grupo completo, no admite quedar parcialmente seleccionado), así que
    // eliminar cualquiera de la lista saca el grupo entero.
    if (this.isGroupSelectionOnly()) {
      this.showDeleteTooltip = false;
      this.isPaxesExpanded = false;
      this.onGroupSelectionChange(false, this.result?.insurances?.[0]);
      return;
    }

    const nuevosPaxes = [...this.paxesSelected];
    nuevosPaxes.splice(index, 1);

    if (nuevosPaxes.length === 0) {
      this.showDeleteTooltip = false;
      this.isPaxesExpanded = false;
    }

    this.paxesChange.emit(nuevosPaxes);
  }

  /**
   * Alterna la visibilidad del listado completo de pasajeros seleccionados
   */
  togglePaxesExpanded(): void {
    this.isPaxesExpanded = !this.isPaxesExpanded;
  }

  /**
   * Obtiene descripción formateada de addons de un pasajero
   * @param passenger Pasajero a analizar
   * @param index Índice del pasajero
   * @returns String formateado con addons del pasajero
   */
  getAddons(passenger: any, index: number): string {
    if (!passenger.addons || passenger.addons.length === 0) {
      return '';
    }

    const addonsMap: { [key: string]: string } = {
      inTravel: 'En viaje',
      isPregnant: 'Embarazada',
      hasPreExistingCondition: 'Condición preexistente'
    };

    // Filtrar addons válidos y mapearlos a sus nombres en español
    const translatedAddons = passenger.addons
      .filter((addon: string) => addonsMap[addon])
      .map((addon: string) => addonsMap[addon]);

    // Si no hay addons válidos después del filtrado
    if (translatedAddons.length === 0) {
      return '';
    }

    let result = '';

    // Si solo tiene el addon 'isPregnant' y tiene semanas de embarazo
    if (translatedAddons.length === 1 && passenger.addons.includes('isPregnant') && passenger.pregnancyWeeks) {
      result = `Embarazada (${passenger.pregnancyWeeks} semanas)`;
    }
    // Si hay múltiples addons
    else {
      result = translatedAddons.join(', ');

      // Si entre los addons está isPregnant y tiene semanas, agregar esa información
      if (passenger.addons.includes('isPregnant') && passenger.pregnancyWeeks) {
        result = result.replace('Embarazada', `Embarazada (${passenger.pregnancyWeeks} semanas)`);
      }
    }

    // Siempre agregar el guión al principio si hay resultado
    return result ? `- ${result}` : '';
  }

  // ============================================
  // MÉTODOS DE DETERMINACIÓN DE MODALIDAD
  // ============================================

  /**
   * Determina la modalidad del seguro basado en palabras clave en los addons
   * @param insurance Seguro a analizar
   * @returns String con la modalidad detectada
   */
  getModalityInsurance(insurance: any): string {
    if (!insurance?.plan?.upgrades || !Array.isArray(insurance.plan.upgrades)) {
      return 'Estándar';
    }

    const modalities = new Set<string>();
    const upgradeNames = insurance.plan.upgrades.map(upgrade => upgrade.name?.toLowerCase() || '');

    this.modalityKeywords.forEach(({ type, keywords }) => {
      const hasMatch = upgradeNames.some(upgradeName =>
        keywords.some(keyword => upgradeName.includes(keyword))
      );

      if (hasMatch) {
        modalities.add(type);
      }
    });

    return modalities.size > 0 ? Array.from(modalities).join(', ') : 'Estándar';
  }

  // ============================================
  // MÉTODOS DE UI Y UTILIDAD
  // ============================================

  /**
   * Alterna visibilidad del tooltip de eliminación
   */
  toggleDeleteTooltip(): void {
    this.showDeleteTooltip = !this.showDeleteTooltip;
  }

  /**
   * Verifica si los datos de cobertura son string (para mostrar condicional)
   * @param data Datos a verificar
   * @returns true si es string
   */
  coverageString(data: any): boolean {
    return typeof data === 'string';
  }

/**
 * Determina si el plan trae el precio discriminado por tipo de pasajero.
 * TODO: hoy la mayoría de los proveedores de categoría 10 (seguros) todavía no
 * envían esta discriminación desde el backend/adapter — se simula leyendo
 * insurance.plan.paxPrices con la misma forma que ya usa modal-tours.component.ts
 * (un registro por paxType con su propio amount). Cuando el proveedor lo traiga
 * de verdad, esto empieza a andar solo, sin tocar el resto del flujo. Si hay menos
 * de 2 tipos con precio propio, no alcanza para discriminar y se descarta.
 */
hasDiscriminatedPaxPricing(insurance: any): boolean {
  const paxPrices = insurance?.plan?.paxPrices;
  if (!Array.isArray(paxPrices)) {
    return false;
  }
  const validTypes = paxPrices.filter((p: any) => p?.paxType && (p?.amount || p?.amount === 0));
  return validTypes.length > 1;
}

/**
 * true si el proveedor de este resultado no discrimina por tipo de pasajero: la
 * selección pasa a ser todo-o-nada (por grupo), no por pasajero individual.
 */
isGroupSelectionOnly(): boolean {
  const insurance = this.result?.insurances?.[0];
  return !!insurance && !this.hasDiscriminatedPaxPricing(insurance);
}

/**
 * true si el grupo está seleccionado. En modo grupo la selección es todo-o-nada
 * (nunca parcial), así que alcanza con que paxesSelected no esté vacío.
 * Ojo: NO comparar contra paxesAvailability.length — ese array excluye a los
 * paxes ya elegidos en CUALQUIER tarjeta (getPaxesDisponiblesParaHijo() en el
 * padre), así que apenas se selecciona el grupo completo ese pool baja a 0 y la
 * comparación deja de cumplirse para siempre.
 */
isGroupSelected(): boolean {
  return !!this.paxesSelected?.length;
}

/**
 * Selección por grupo: todo o nada. Arma los paxes con la misma forma que ya usa
 * onSelectionChange()/asignarSeguroANuevos(), para que el resto del flujo
 * (paxesChange, add(), getPricesTotalQuote()) siga funcionando sin cambios.
 */
onGroupSelectionChange(checked: boolean, insurance: any): void {
  if (!checked) {
    this.paxesChange.emit([]);
    return;
  }

  const seleccionGrupal = (this.paxesAvailability || []).map(pax => ({
    ...pax,
    insurance: { ...insurance },
    insuranceSelectedAt: new Date().toISOString(),
    insurancePlanId: insurance?.plan?.planId
  }));

  this.paxesChange.emit(seleccionGrupal);
}

getPricesTotalQuote(totalPriceProf: any): number {
  // Si no hay paxes seleccionados, usar precio base
  if (!this.paxesSelected || this.paxesSelected.length === 0) {
    return this.parsePrice(totalPriceProf) || 0;
  }

  // Selección por grupo (proveedor sin discriminación por tipo de pasajero): el
  // precio ya es el total del grupo completo, no corresponde sumarlo por cada
  // pasajero seleccionado.
  const firstInsurance = this.paxesSelected[0]?.insurance;
  if (firstInsurance && !this.hasDiscriminatedPaxPricing(firstInsurance)) {
    return this.parsePrice(firstInsurance.plan?.totalPriceProf ?? totalPriceProf) || 0;
  }

  const total = this.paxesSelected.reduce((sum, pax) => {
    // Verificar que el pax tenga insurance
    if (!pax?.insurance) {
      console.warn(`Pax ${pax.tempId} no tiene insurance`);
      return sum;
    }

    // Verificar que el insurance tenga plan
    if (!pax.insurance.plan) {
      console.warn(`Pax ${pax.tempId} insurance no tiene plan`);
      return sum;
    }

    // Obtener y parsear el precio
    const precioRaw = pax.insurance.plan.totalPriceProf;
    const precio = this.parsePrice(precioRaw);

    return sum + precio;
  }, 0);

  return total;
}

/**
 * Convierte cualquier valor a número (maneja strings, null, undefined)
 */
private parsePrice(price: any): number {
  if (price === null || price === undefined || price === '') {
    return 0;
  }

  const num = Number(price);
  if (isNaN(num)) {
return 0;
}

  // Redondear a 2 decimales para coincidir con el cálculo del backend
  return Math.round(num * 100) / 100;
}

getQtyPlansSelected(): string {
  if (!this.paxesSelected || this.paxesSelected.length === 0) {
    return '';
  }

  // Obtener todos los planId únicos
  const uniquePlanIds = new Set<string>();

  this.paxesSelected.forEach((pax: any) => {
    if (pax?.insurance?.plan?.planId) {
      uniquePlanIds.add(pax.insurance.plan.planId);
    }
  });

  const distinctPlans = uniquePlanIds.size;

  if(this.isGroupSelectionOnly()) {
    return 'Grupo x plan';
  }

  if (distinctPlans === 0) {
    return '';
  } else if (distinctPlans === 1) {
    return '1X plan';
  } else {
    return `${distinctPlans}X planes`;
  }
}

getPaxConditions(pax): boolean {

  if(pax.addons && pax.addons.length > 0) {
    return true;
  }

  return false;
}

getValueConditions(pax: any): string {
  if (!pax.addons || pax.addons.length === 0) {
    return '';
  }

  const addonsMap: { [key: string]: string } = {
    inTravel: 'En viaje',
    isPregnant: 'Embarazada',
    hasPreExistingCondition: 'Condición preexistente'
  };

  // Mapear y formatear los addons
  const formattedAddons: string[] = [];

  pax.addons.forEach((addon: string) => {
    if (addonsMap[addon]) {
      let formatted = addonsMap[addon];

      // Caso especial: embarazada con semanas
      if (addon === 'isPregnant' && pax.pregnancyWeeks) {
        formatted = `Embarazada (${pax.pregnancyWeeks} semanas)`;
      }

      formattedAddons.push(`• ${formatted}`);
    }
  });

  // Si no hay addons válidos
  if (formattedAddons.length === 0) {
    return '';
  }

  // Crear string con saltos de línea
  return `Condiciones:\n${formattedAddons.join('\n')}`;
}


get getBlickoins(): number {
  let blickoins = 0;

  blickoins = this.result?.insurances[0].plan?.profility?.blickoins;

  return blickoins;
}


}
